<template>
  <b-modal
    id="duplicate-page-modal"
    :title="trans('duplicate')"
    :ok-title="trans('duplicate')"
    :ok-disabled="busy"
    :cancel-title="trans('cancel')"
    @ok="onDuplicate"
    @shown="onShown"
  >
    <b-form-group :label="trans('name')">
      <b-input v-model="name" :disabled="busy" />
    </b-form-group>
    <b-form-group v-if="organizations && organizations.length > 1" :label="trans('target_organization')">
      <b-form-select
        v-model="target_organization_id"
        :options="organizationOptions"
        :disabled="busy"
      ></b-form-select>
    </b-form-group>

    <p v-if="!!organizations && target_organization_id != organization.id" class="mt-2">
      <small v-html="trans('page_create_from_sample_note')"></small>
    </p>
    <b-form-group v-if="showDuplicateOption" :label="trans('page_duplicate_forms_classes')">
      <b-form-radio-group
        v-model="duplicate_forms_classes"
        :options="[{value: true, text: trans('yes')}, {value: false, text: trans('no')}]"
        :disabled="busy"
      ></b-form-radio-group>
      <b-form-text>
        {{ trans('page_duplicate_forms_classes_about') }}
      </b-form-text>
    </b-form-group>

    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  export default {
    props: {
      organization: Object,
      page: Object,
      isStaff: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        name: null,
        target_organization_id: this.organization.id,
        organizations: null,
        blocks: null,
        duplicate_forms_classes: false,
      }
    },
    computed: {
      organizationOptions() {
        return _.map(this.organizations || [], o => {
          return {
            value: o.id,
            text: o.name,
          }
        })
      },
      targetOrganizationName() {
        return _.reduce(this.organizations || [], (name, o) => {
          if (o.id == this.target_organization_id) name = o.name
          return name
        }, null)
      },
      showDuplicateOption() {
        return !!this.organizations &&
          this.target_organization_id != this.organizationOptions.id &&
          !!this.blocks &&
          this.blocks.length > 0
          _.reduce(this.blocks, (has, block) => {
            if (block.recipient_list_id) has = true
            return has
          }, false)
      },
    },
    methods: {
      onShown() {
        this.busy = false
        this.error = null
        this.name = trans('copy_of') + ' ' + this.page.name
        this.target_organization_id = this.organization.id
        this.organizations = null
        this.blocks = null
        this.duplicate_forms_classes = false
        this.loadOrganizations().then(this.loadBlocks)
      },
      loadOrganizations() {
        this.busy = true
        this.error = null
        let url = `/organization`
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.organizations = response.data
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      loadBlocks() {
        this.busy = true
        this.error = null
        this.blocks = null
        if (!this.page.id) return

        let url = `/organization/${this.organization.id}/page/${this.page.id}`
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.blocks = response.data.blocks
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onDuplicate(e) {
        e.preventDefault()
        this.busy = true
        this.error = null
        let url = `/organization/${this.target_organization_id}/page/${this.page.id}/duplicate`
        axios.post(url, {
          source_id: this.page.id,
          type: this.page.type,
          name: this.name,
          description: this.page.description,
          is_staff: this.isStaff,
          passcode: null,
          passcode_required: false,
          permission: this.page.permission,
          duplicate_forms_classes: this.target_organization_id == this.organization.id ? this.duplicate_forms_classes : true,
        })
        .then(response => {
          if (this.organization.id == this.target_organization_id) {
            window.location = _.iframeUrlPrefix + response.data.uri
            return
          }
          let win = window.open(response.data.url, '_blank')
          if (win) win.focus()
          this.busy = false
          _.toastSuccess(this, trans('copy_created_in_org').replace(':org', this.targetOrganizationName))
          this.$bvModal.hide('duplicate-page-modal')
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window.duplicatePageModal = this
    },
  }
</script>